import type { IconProps } from "./types";

export function Plus({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.90039 0C8.39745 0 8.80078 0.403334 8.80078 0.900391V7H14.9004C15.3974 7 15.8008 7.40333 15.8008 7.90039C15.8008 8.39745 15.3974 8.80078 14.9004 8.80078H8.80078V14.9004C8.80078 15.3974 8.39745 15.8008 7.90039 15.8008C7.40333 15.8008 7 15.3974 7 14.9004V8.80078H0.900391C0.403334 8.80078 0 8.39745 0 7.90039C0 7.40333 0.403334 7 0.900391 7H7V0.900391C7 0.403334 7.40333 0 7.90039 0Z"
        fill={currentColor}
        transform="translate(4.1 4.1)"
      />
    </svg>
  );
}
